import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from "@angular/forms";
import { Subject, takeUntil } from 'rxjs';
import { ODataService } from '@ui-kit/odata';


@Component({
  selector: 'patient-edit',
  templateUrl: './edit.html'
})
export class PatientEditComponent implements OnDestroy {

  @Output() profileSaved: EventEmitter<any> = new EventEmitter<any>();

  public form: FormGroup | undefined = undefined;
  public isEdit = false;
  public errMessage: string = '';

  private isSaving = false;
  private readonly unsubscribe$ = new Subject<void>();

  @Input() set patientDetails(value: any) {

    this.isEdit = false;
    this.errMessage = '';

    if (!value) {
      this.form = undefined;
      return;
    }

    this.isEdit = value.id;

    this.form = new FormGroup({
      patientId: new FormControl(value.id),

      lastName: new FormControl(value.lastName),
      firstName: new FormControl(value.firstName),
      patronymic: new FormControl(value.patronymic),
      phone1: new FormControl(value.phone1),
    });
  }


  constructor(private odata: ODataService) { }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  public save(): void {
    if (!this.form) {
      return;
    }
    
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.isSaving) { return; }
    this.isSaving = true;
    this.errMessage = ''

    if (this.isEdit) {
      // Update requisites
      this.odata.post('patients', { params: { action: "update" }, body: this.form.value })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({ 
          next: (xx: any) => {
            this.isSaving = false;
            sessionStorage.setItem('patient.id', xx.masterId); // use sessionStorage - while development - to work with prev-saved patient
            this.profileSaved.emit(xx.id); 
          }, 
          error: () => {
            this.isSaving = false;
            this.errMessage = 'Помилка';
          } 
        });

    } else {
      // Identification
      this.odata.get('patients', { 
          params: { 
            filter: { and: {
              lastName: { eq: this.form.value.lastName },
              firstName: { eq: this.form.value.firstName },
              phone1: { eq: this.form.value.phone1 },
            }},
            select: ['id', 'masterId']
          } 
        })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((xx: any[]) => {
          
          this.isSaving = false; 

          if (xx.length > 0) {
            sessionStorage.setItem('patient.id', xx[0].masterId); // use sessionStorage - while development - to work with prev-saved patient
            this.profileSaved.emit(xx[0].id);
          } else {
            this.errMessage = 'Запис не знайдено'
          }

        });
    }


  }

  public cancel = () => { this.profileSaved.emit(null); } 
}
